import { AxiosResponse } from "axios";

import { API } from "../index";


export type SpotUnavailableReason = "maintenance" | "operation" | "private_event" | "repair" | "other";

export type SpotUnavailablePeriod = {
  id: number;
  spot: number;
  spot_name: string;
  package: number;
  package_name: string;
  start_date: string;
  end_date: string;
  reason: SpotUnavailableReason;
  memo: string;
  is_active: boolean;
  overlapping_reservation_count: number;
  created_at: string;
  updated_at: string;
};

export type SpotUnavailablePayload = {
  spot: number;
  start_date: string;
  end_date: string;
  reason: SpotUnavailableReason;
  memo?: string;
  is_active?: boolean;
};

export type PaginatedResponse<T> = {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
};

const BASE = "/api/v2/spot-unavailabilities/";

export const spotUnavailabilityService = {
  list: (params?: Record<string, any>): Promise<AxiosResponse<PaginatedResponse<SpotUnavailablePeriod>>> =>
    API.get(BASE, { params }),

  create: (payload: SpotUnavailablePayload): Promise<AxiosResponse<SpotUnavailablePeriod>> =>
    API.post(BASE, payload),

  update: (id: number, payload: Partial<SpotUnavailablePayload>): Promise<AxiosResponse<SpotUnavailablePeriod>> =>
    API.patch(`${BASE}${id}/`, payload),
};
